import {
  FileTrackerStageEnum,
  FileTrackerDetailProps,
  FileTrackerLayer,
  FileTrackerLayerStatus,
  FileTrackerListFileProps,
  completedStates,
  inProgStates,
  failedStates,
  FileStageStatus,
  LayerStatusEnum,
  LayersProcessMap,
  FileUploadLayers,
} from '../file-tracker-types';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Text,
  Flex,
  useDisclosure,
  Center,
} from '@chakra-ui/react';
import { AiOutlineFileText } from 'react-icons/ai/index.js';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  AccordionTimeline,
  Timeline,
  TimelineDataProps,
  Spin,
} from '@ssar-app/uikit';

interface FileStatusProps {
  isOpen: boolean;
  setonOpen: (value: React.SetStateAction<boolean>) => void;
  fileDetails?: FileTrackerDetailProps | undefined;
  isLoading: boolean;
  record: FileTrackerListFileProps;
}

export const QuickViewFile = (props: FileStatusProps) => {
  const { isOpen, setonOpen, fileDetails, isLoading, record } = props;
  const [timelineData, setTimelineData] = useState<TimelineDataProps[]>([]);
  const { onClose } = useDisclosure();

  const getStageStatus = (stage: string) => {
    return inProgStates.includes(stage)
      ? FileStageStatus.In_Progress
      : failedStates.includes(stage)
      ? FileStageStatus.Failed
      : [
          FileTrackerStageEnum.FILE_SAMPLING_COMPLETED as string,
          FileTrackerStageEnum.MALWARE_SCAN_COMPLETED,
        ].includes(stage)
      ? FileStageStatus.Completed
      : [FileTrackerStageEnum.FILE_IS_AVAILABLE as string].includes(stage)
      ? FileStageStatus.File_is_Available
      : FileStageStatus.File_Received;
  };
  const getTimelineStatus = (entry: FileTrackerLayer) => {
    if (entry != undefined) {
      return completedStates.includes(entry.statuses[0].name)
        ? LayerStatusEnum.success
        : failedStates.includes(entry.statuses[0].name)
        ? LayerStatusEnum.error
        : inProgStates.includes(entry.statuses[0].name)
        ? LayerStatusEnum.inprogress
        : LayerStatusEnum.waiting;
    } else {
      return LayerStatusEnum.waiting;
    }
  };

  useEffect(() => {
    if (
      fileDetails &&
      Object.keys(fileDetails).length > 0 &&
      fileDetails.layers.length > 0
    ) {
      setTimelineData(
        fileDetails.layers
          .slice(0)
          .reverse()
          .map((entry: FileTrackerLayer) => ({
            title: LayersProcessMap[entry.name] || entry.name,
            titleIcon: AiOutlineFileText,
            status: getTimelineStatus(entry),
            details:
              entry != undefined &&
              entry.name.toLowerCase() != FileUploadLayers.Sts.toLowerCase() ? (
                <Timeline>
                  {entry.statuses
                    .slice(0)
                    .reverse()
                    .map((stageData: FileTrackerLayerStatus, index: number) => (
                      <Timeline.Item
                        key={index}
                        label={getStageStatus(stageData.name)}
                      >
                        {dayjs(stageData.updateTime).format(
                          'YYYY-MMM-DD HH:mm:ss [GMT]ZZ',
                        )}
                      </Timeline.Item>
                    ))}
                </Timeline>
              ) : (
                <Text>
                  {entry != undefined
                    ? dayjs(entry.statuses[0].updateTime).format(
                        'YYYY-MMM-DD HH:mm:ss [GMT]ZZ',
                      )
                    : ''}
                </Text>
              ),
            subTitle: (
              <Text fontSize='14px'>
                {entry != undefined
                  ? entry.name !== FileUploadLayers.Sts
                    ? entry.name.replace(/[A-Z]/g, ' $&').trim()
                    : entry.name
                  : ''}
              </Text>
            ),
          })),
      );
    }
  }, [fileDetails]);
  return (
    <Drawer
      onClose={() => {
        setonOpen(false);
        onClose();
        setTimelineData([]);
      }}
      isOpen={isOpen}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={false}
      size={'sm'}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>File Upload Status</DrawerHeader>

        <DrawerBody>
          <Spin spinning={isLoading} tip='Loading File Upload Status'>
            {record && Object.keys(record).length > 0 && (
              <Flex direction='column' mb='20px'>
                <Text p={0.5} fontSize='sm' fontWeight='semibold'>
                  {record.fileName}
                </Text>
                <Text p={0.5} fontSize='xs'>
                  Upload Source:{' '}
                  {record.uploadSource ? record.uploadSource : ''}
                </Text>
                <Text p={0.5} fontSize='xs'>
                  Uploaded By: {record.uploadedBy ? record.uploadedBy : ''}
                </Text>
              </Flex>
            )}
            {Object.keys(timelineData).length > 0 ? (
              <AccordionTimeline
                data={timelineData}
                accordionProps={{
                  defaultIndex: Object.keys(timelineData).map((index) =>
                    parseInt(index),
                  ),
                }}
                detailsProps={{ pb: 2, pt: 4 }}
              />
            ) : !isLoading ? (
              <Center>
                <Text sx={{ fontWeight: 'bold', p: 5 }}>
                  {' '}
                  File Upload Status Not Found{' '}
                </Text>
              </Center>
            ) : (
              ''
            )}
          </Spin>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
